<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" class="p-button-danger" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-4xl">Anagrafica</label>
</div>

<div class="flex-container">
  <app-header-dashboard [showBtnRedirect]="false"></app-header-dashboard>
  <div class="col-3 flex flex-wrap justify-content-end pr-4 pl-2 mt-2">
    <img [src]="'assets/img/' + baseImagePath +'/IconaCV.png'" style="max-width: 100%; height: auto;" class="cvIcon cursor-pointer" (click)="loadProfileCvClick()">
    <input type="file" id="profileCv"
           name="profileCv"
           #profileCv
           style="display: none"
           accept=".pdf"
           (change)="loadProfileCv($event.target)">
    <label class="w-full flex justify-content-end text-sm lg:mr-3" style="color: var(--secondary)"> Formato richiesto: PDF</label>

    <div class="col-12 flex justify-content-end">
      <div *ngIf="cvLoaded" class="col-12 lg:col-4 flex justify-content-end lg:mr-5">
        <i class="pi pi-search ml-2 mr-2 font-bold cursor-pointer" [pTooltip]="'Visualizza'" (click)="showProfileCv()"></i>
        <i class="pi pi-download ml-2 font-bold cursor-pointer" [pTooltip]="'Scarica'" (click)="downloadProfileCv()"></i>
      </div>
    </div>
    <label class="w-full flex justify-content-end mt-3 text-xs text-orientation-left">Ultimo aggiornamento: {{registryDto.DataUltimoAggiornamentoCVSTR}}</label>
  </div>
</div>

<div class="col-12 mt-8 p-5">
  <label class="w-full text-900 text-3xl">Dati personali</label>
  <form id="dettaglioAnagraficaForm" name="dettaglioAnagraficaForm" #dettaglioAnagraficaForm="ngForm" autocomplete="off">
    <p-card styleClass="bg-dashboard-card mt-5 border-round-3xl">
      <div class="col-12 block">
        <div class="w-full flex">
          <label class="labelWidth texts">Nome</label>
          <div class="w-full block p-0">
            <input id="name"
                   name="name"
                   type="text"
                   pInputText
                   class="w-full"
                   [(ngModel)]="registryDto.Nome"
                   [disabled]="true"
                   #name='ngModel'>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Cognome</label>
          <div class="w-full block p-0">
            <input id="surname"
                   type="text"
                   name="surname"
                   pInputText
                   class="w-full"
                   [(ngModel)]="registryDto.Cognome"
                   [disabled]="true"
                   #surname='ngModel'>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full field flex">
          <label class="mt-2 labelWidth texts">Luogo di nascita</label>
          <div class="w-full block">
            <input id="birthPlace"
                   type="text"
                   pInputText
                   name="birthPlace"
                   class="w-full"
                   [(ngModel)]="registryDto.ComuneNascita"
                   [disabled]="true"
                   #birthPlace='ngModel'>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full field flex">
          <label class="mt-2 labelWidth texts">Data di Nascita</label>
          <div class="w-full block">
            <p-calendar [showIcon]="true"
                        inputId="icon"
                        styleClass="w-full"
                        appendTo="body"
                        dateFormat="{{displayDateFormat}}"
                        yearRange="{{yearRange}}"
                        class="w-full"
                        name="birthDate"
                        [(ngModel)]="registryDto.DataNascita"
                        [disabled]="true"
                        #birthDate='ngModel'></p-calendar>

          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full field flex">
          <label class="mt-2 labelWidth texts">Sesso</label>
          <div class="w-full block p-0">
            <p-radioButton name="genderGroup"
                           [value]="'M'"
                           label="Maschio"
                           class="texts mx-2"
                           [(ngModel)]="registryDto.Sesso"
                           [disabled]="true"
                           #genderGroup='ngModel'></p-radioButton>
            <p-radioButton name="genderGroup"
                           [value]="'F'"
                           label="Femmina"
                           class="texts"
                           [(ngModel)]="registryDto.Sesso"
                           [disabled]="true"
                           #genderGroup='ngModel'></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Nazionalità *</label>
          <div class="w-full block p-0">
            <p-autoComplete [(ngModel)]="nazioneSelezionata"
                            [suggestions]="nazioniList"
                            field="NazioneNome"
                            (completeMethod)="getNazioniAutoComplete($event)"
                            styleClass="w-full"
                            name="nazioneResidenza"
                            #nazioneResidenza='ngModel'
                            [required]="true">
              <ng-template let-comune pTemplate="item">
                <div class="person-item">
                  <div>{{comune.NazioneNome}}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <div *ngIf="nazioneResidenza.invalid && (nazioneResidenza.dirty || nazioneResidenza.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="nazioneResidenza.errors?.['required']">
                Campo obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Stato civile *</label>
          <div class="w-full block p-0">
            <p-radioButton name="maritialStatusGroup" class="texts mx-2" [value]="0" label="Non dichiarato" [(ngModel)]="registryDto.IdStatoCivile" #maritialStatusGroup='ngModel'></p-radioButton>
            <p-radioButton name="maritialStatusGroup"
                           class="texts"
                           [value]="1"
                           label="Celibe/Nubile"
                           [(ngModel)]="registryDto.IdStatoCivile"
                           #maritialStatusGroup='ngModel'></p-radioButton>
            <p-radioButton name="maritialStatusGroup"
                           class="texts mx-2"
                           [value]="2" label="Coniugato/a"
                           [(ngModel)]="registryDto.IdStatoCivile"
                           #maritialStatusGroup='ngModel'></p-radioButton>
            <p-radioButton name="maritialStatusGroup" class="texts" [value]="3" label="Divorziato/a" [(ngModel)]="registryDto.IdStatoCivile" #maritialStatusGroup='ngModel'></p-radioButton>
            <p-radioButton name="maritialStatusGroup" class="texts mx-2" [value]="4" label="Vedovo/a" [(ngModel)]="registryDto.IdStatoCivile" #maritialStatusGroup='ngModel'></p-radioButton>
            <p-radioButton name="maritialStatusGroup" class="texts" [value]="5" label="Separato/a" [(ngModel)]="registryDto.IdStatoCivile" #maritialStatusGroup='ngModel'></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full field flex">
          <label class="mt-2 labelWidth texts">Codice fiscale *</label>
          <div class="w-full block">
            <input id="fiscalCode"
                   type="text"
                   pInputText
                   class="w-full"
                   name="fiscalCode"

                   [(ngModel)]="registryDto.CodiceFiscale"
                   [disabled]="true"
                   #fiscalCode='ngModel'>

          </div>
        </div>
      </div>
    </p-card>

    <div class="col-12 flex justify-content-end">
      <div class="col-12 md:col-2 xl:col-2 p-0">
        <button pButton pRipple label="Salva" class="mt-4 mb-2 w-full p-button-rounded" (click)="registryUpdate()"></button>
      </div>
    </div>

    <p-card styleClass="bg-dashboard-card mt-5 mb-5 border-round-3xl">
      <div class="col-12 block">
        <div class="w-full flex">
          <label class="labelWidth texts">Indirizzo di residenza *</label>
          <div class="w-full block p-0">
            <input id="residenceAddress"
                   type="text"
                   pInputText
                   name="residenceAddress"
                   class="w-full"
                   [(ngModel)]="registryDto.IndirizzoResidenza"
                   #residenceAddress='ngModel'
                   required>
            <div *ngIf="residenceAddress.invalid && (residenceAddress.dirty || residenceAddress.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="residenceAddress.errors?.['required']">
                Campo obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Comune di residenza *</label>
          <div class="w-full block p-0">
            <p-autoComplete [(ngModel)]="comuneResidenzaSelezionato"
                            [suggestions]="comuniList"
                            field="ComuneDescrizione"
                            (completeMethod)="getComuniAutoComplete($event)"
                            styleClass="w-full"
                            name="comuneResidenza"
                            #comuneResidenza='ngModel'
                            [required]="true">
              <ng-template let-comune pTemplate="item">
                <div class="person-item">
                  <div>{{comune.ComuneDescrizione}}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <div *ngIf="comuneResidenza.invalid && (comuneResidenza.dirty || comuneResidenza.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="comuneResidenza.errors?.['required']">
                Campo obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="w-full texts">Il tuo indirizzo di residenza coincide con quello di domicilio?</label>
          <div class="w-full block p-0">
            <p-radioButton name="domicileMatchesResidenceGroup" class="texts mx-2" [value]="true" label="Si" [(ngModel)]="registryDto.ResidenzaCombaciaConDomicilio"></p-radioButton>
            <p-radioButton name="domicileMatchesResidenceGroup" class="texts" [value]="false" label="No" [(ngModel)]="registryDto.ResidenzaCombaciaConDomicilio"></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12 block" *ngIf="!registryDto.ResidenzaCombaciaConDomicilio">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Indirizzo di domicilio *</label>
          <div class="w-full block p-0">
            <input id="domicileAddress"
                   type="text"
                   pInputText
                   name="domicileAddress"
                   class="w-full"
                   #domicileAddress='ngModel'
                   [(ngModel)]="registryDto.IndirizzoDomicilio"
                   required>
            <div *ngIf="domicileAddress.invalid && (domicileAddress.dirty || domicileAddress.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="domicileAddress.errors?.['required']">
                Campo obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 block" *ngIf="!registryDto.ResidenzaCombaciaConDomicilio">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Comune di domicilio *</label>
          <div class="w-full block p-0">
            <p-autoComplete [(ngModel)]="comuneDomicilioSelezionato"
                            [suggestions]="comuniList"
                            field="ComuneDescrizione"
                            name="ComuneDescrizione"
                            #ComuneDescrizione='ngModel'
                            (completeMethod)="getComuniAutoComplete($event)"
                            styleClass="w-full"
                            [required]="true">
              <ng-template let-comune pTemplate="item">
                <div class="person-item">
                  <div>{{comune.ComuneDescrizione}}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <div *ngIf="ComuneDescrizione.invalid && (ComuneDescrizione.dirty || ComuneDescrizione.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="ComuneDescrizione.errors?.['required']">
                Campo obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>

    <div class="col-12 flex justify-content-end">
      <div class="col-12 md:col-2 xl:col-2 p-0">
        <button pButton pRipple label="Salva" class="mt-4 mb-2 w-full p-button-rounded" (click)="registryUpdate()"></button>
      </div>
    </div>

    <label class="w-full text-900 text-3xl">Contatti</label>
    <p-card styleClass="bg-dashboard-card mt-5 mb-5 border-round-3xl">
      <div class="col-12 block">
        <div class="w-full flex">
          <label class="labelWidth texts">Email principale *</label>
          <div class="w-full block p-0">
            <input id="email"
                   type="text"
                   pInputText
                   class="w-full"
                   [(ngModel)]="registryDto.Email"
                   name="email"
                   #email='ngModel'>
            <div *ngIf="email.invalid && (email.dirty || email.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="email.errors?.['required']">
                Campo obbligatorio.
              </div>
              <div class="errorMsg" *ngIf="email.errors?.['pattern']">
                Email non valida
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Numero di cellulare *</label>
          <div class="w-full block p-0">
            <input id="mobilePhone"
                   type="text"
                   pInputText
                   class="w-full"
                   name="mobilePhone"
                   [(ngModel)]="registryDto.Cellulare"
                   #mobilePhone='ngModel'
                   required>
            <div *ngIf="mobilePhone.invalid && (mobilePhone.dirty || mobilePhone.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="mobilePhone.errors?.['required']">
                Campo obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Numero fisso</label>
          <div class="w-full block p-0">
            <input id="phoneNumber"
                   type="text"
                   pInputText
                   class="w-full"
                   name="phoneNumber"
                   [(ngModel)]="registryDto.TelefonoFisso"
                   #phoneNumber='ngModel'>
            <div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched || submittedPage)"
                 class="alert mt-2">

              <div class="errorMsg" *ngIf="phoneNumber.errors?.['required']">
                Campo obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>

    <div class="col-12 flex justify-content-end">
      <div class="col-12 md:col-2 xl:col-2 p-0">
        <button pButton pRipple label="Salva" class="mt-4 mb-2 w-full p-button-rounded" (click)="registryUpdate()"></button>
      </div>
    </div>

    <label class="w-full text-900 text-3xl">Altro</label>
    <p-card styleClass="bg-dashboard-card mt-5 border-round-3xl">
      <div class="col-12 block">
        <div class="w-full flex">
          <label *ngIf="profileSex == 'M'" class="labelWidth texts">Automunito *</label>
          <label *ngIf="profileSex == 'F'" class="labelWidth texts">Automunita *</label>
          <div class="w-full block p-0">
            <p-radioButton name="selfPropelledGroup"
                           class="texts mx-2"
                           [value]="true"
                           label="Si"
                           [(ngModel)]="registryDto.Automunito"
                           #selfPropelledGroup='ngModel'></p-radioButton>


            <p-radioButton name="selfPropelledGroup" class="texts" [value]="false" label="No" [(ngModel)]="registryDto.Automunito" #selfPropelledGroup='ngModel'></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Categoria protetta *</label>
          <div class="w-full block p-0">
            <p-radioButton name="protectedCategoryGroup" class="texts mx-2" [value]="true" label="Si" [(ngModel)]="registryDto.CategoriaProtetta" #protectedCategoryGroup='ngModel'></p-radioButton>
            <p-radioButton name="protectedCategoryGroup" class="texts" [value]="false" label="No" [(ngModel)]="registryDto.CategoriaProtetta" #protectedCategoryGroup='ngModel'></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12 block">
        <div class="w-full flex mt-2">
          <label class="labelWidth texts">Patente di Guida </label>
          <div class="w-full block p-0">
            <p-checkbox  [binary]="true" name="driveLicenseA" class="texts" label="Patente A" [(ngModel)]="registryDto.PatenteA" class="mr-2 texts"></p-checkbox>
            <p-checkbox  [binary]="true" name="driveLicenseB" class="texts" label="Patente B" [(ngModel)]="registryDto.PatenteB" class="mr-2 texts"></p-checkbox>
            <p-checkbox  [binary]="true" name="driveLicenseC" class="texts" label="Patente C" [(ngModel)]="registryDto.PatenteC" class="mr-2 texts"></p-checkbox>
            <p-checkbox  [binary]="true" name="driveLicenseD" class="texts" label="Patente D" [(ngModel)]="registryDto.PatenteD" class="mr-2 texts"></p-checkbox>
            <p-checkbox  [binary]="true" name="driveLicenseE" class="texts" label="Patente E" [(ngModel)]="registryDto.PatenteE" class="mr-2 texts"></p-checkbox>
          </div>
        </div>
      </div>

    </p-card>

    <div class="col-12 flex justify-content-end">
      <div class="col-12 md:col-2 lg:col-2 p-0">
        <button pButton pRipple label="Salva" class="mt-4 mb-2 w-full p-button-rounded" (click)="registryUpdate()"></button>
      </div>
    </div>
  </form>
</div>

<!--
<p-dialog [header]="'Visualizza cv'" [(visible)]="showModalCv" [modal]="true" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">
  <app-document-show [blob]="blobCv"
                     [src]="srcCv"
                     [fileName]="fileName"></app-document-show>
  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>
-->

<p-dialog [header]="'Visualizza cv'" [(visible)]="showModalCv" [modal]="true" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">
  <app-document-show
                     [blob]="blobCv"
                     [src]="srcCv"
                     [fileName]="fileName"></app-document-show>

  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>
